import { render, staticRenderFns } from "./films.vue?vue&type=template&id=4e94c7b9&scoped=true&"
import script from "./films.vue?vue&type=script&lang=js&"
export * from "./films.vue?vue&type=script&lang=js&"
import style0 from "./films.vue?vue&type=style&index=0&id=4e94c7b9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e94c7b9",
  null
  
)

export default component.exports